import { createApp } from "vue"
import { RouterView } from "vue-router"
import { LoadingWrapper } from "./composition/useLoading"
import { waitDocumentLoad } from "./utils/docUtils"
import "./style.css"

import "vue-utils/dist/style.css"
import router from "./Pages/routes"
import Popups from "./components/Popups"

await waitDocumentLoad()

const appMountPoint = document.getElementById("spaContent")
if (appMountPoint) {
	const app = createApp({
		name: "DeicderPWAUI",
		setup() {
			return () => (
				<>
					<LoadingWrapper>
						<RouterView />
					</LoadingWrapper>
					<Popups />
				</>
			)
		},
	})
	app.use(router)
	app.mount(appMountPoint)
}
